<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/configuration']">Configuración</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li *ngIf="view"><a [routerLink]="['/configuration/origins']">{{view.getEntityBaseName(true)}}</a></li>
</ul>
<app-view #view [code]="'origins.list'" [model]="originsFilters" (onEvent)="onEvent($event)"></app-view>
